import React from 'react';
import { BannerWrapper } from '@fiverr-private/gig_listings';
import { FiProEntryBanner } from './FiProEntryBanner';

interface FiProEntryBannerResolverWithWrapperProps {}

export const FiProEntryBannerResolverWithWrapper = (props: FiProEntryBannerResolverWithWrapperProps) =>
    BannerWrapper(<FiProEntryBanner {...props} />)({
        className: 'fip-entry-banner-listings',
        bannerRow: 1,
    });
